<div [hidden]="!detailsLoaded || !journeysLoaded || !servicesLoaded">
  <div class="flex-grow-1">
    <div class="row flex-grow-1">
      <div class="col-md-4 col-12 pr-1 flex-grow-1 d-flex flex-column">
        <div appSetHeight [padding]="20" class="col-12 pl-0 pr-0 mt-1 flex-grow-1">
            <div class="h-35 overflow-auto">
                <table class="location-info">
                    <tbody>
                        <tr>
                            <td class="text-uppercase py-2 fw-bolder pr-4">Type: </td>
                            <td>{{ location.locationType }}</td>
                        </tr>
                        <tr>
                            <td class="text-uppercase py-2 fw-bolder" pr-4>Average Dwell Time: </td>
                            <td>{{ avgDwellSubTitle }}</td>
                        </tr>
                        <tr>
                            <td class="text-uppercase py-2 fw-bolder pr-4">Average Turnaround Time: </td>
                            <td>{{ avgTurnaroundSubTitle }}</td>
                        </tr>
                        <tr>
                            <td class="single text-uppercase py-2 fw-bolder pr-4" colspan="2">
                                Container Types:<br>
                                <table class="types">
                                    <tr *ngIf="hasRoRo">
                                        <td (click)="toggleSummaryRow('RoRo')" title="Expand" class="controls clickable"><div class="type"><i *ngIf="openType != 'RoRo'" class="material-icons">add</i><i *ngIf="openType == 'RoRo'" class="material-icons">remove</i> RoRo</div></td>
                                        <td>{{ getTypeTotal(locationRoRoGroups) }}</td>
                                    </tr>
                                    <tbody *ngIf="openType == 'RoRo'">
                                        <tr *ngFor="let item of locationRoRoGroups">
                                            <td class="typeItem">{{ item.groupName }}</td>
                                            <td>{{ item.count }}</td>
                                        </tr>
                                    </tbody>
                                    <tr *ngIf="hasSkips">
                                        <td (click)="toggleSummaryRow('Skips')" title="Expand" class="controls clickable"><div class="type"><i *ngIf="openType != 'Skips'" class="material-icons">add</i><i *ngIf="openType == 'Skips'" class="material-icons">remove</i> Skips</div></td>
                                        <td>{{ getTypeTotal(locationSkipGroups) }}</td>
                                    </tr>
                                    <tbody *ngIf="openType == 'Skips'">
                                        <tr *ngFor="let item of locationSkipGroups">
                                            <td class="typeItem">{{ item.groupName }}</td>
                                            <td>{{ item.count }}</td>
                                        </tr>                                    
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>              
            </div>
            <div class="h-65 overflow-auto">
                <table class="location-info">
                    <tbody>
                        <tr *ngIf="totalOrders != null">
                            <td class="text-uppercase py-2 fw-bolder pr-4">Containers On Site: </td>
                            <td>{{ assetsOnSite.length }}</td>
                        </tr>
                        <tr *ngIf="totalOrders != null">
                            <td class="text-uppercase py-2 fw-bolder pr-4">Total Contracts: </td>
                            <td>{{ totalOrders }}</td>
                        </tr>
                    </tbody>
                </table>                   
                <div class="table-box">
                    <div class="row w-100 assets" *ngIf="isIntegrationCustomer === false">
                        <ng-container *ngFor="let asset of assetsOnSite; let i = index;">
                            <div class="item col-6 d-flex align-items-stretch">
                                <div class="card m-1 w-100">
                                    <span class="container-icon text-primary me-2 me-md-0 relative-top--2" (click)="openPopup(asset.assetURL === null ? 'https://pinwebsiteimages.blob.core.windows.net/binreportimages/10000_OPN_image_front.jpg' : asset.assetURL)">
                                        <img src="/img/RoRo.png" *ngIf="asset.assetTypeClassification == 0">
                                        <img src="/img/Skip.png" *ngIf="asset.assetTypeClassification == 1">
                                    </span>
                                    <table class="asset-item">
                                        <tr *ngIf="asset.order">
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Contract:</td>
                                            <td class="value">{{ asset.order }} </td>
                                        </tr>
                                        <tr>
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Container:</td>
                                            <td class="value">{{ asset.id }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Type:</td>
                                            <td class="value">{{ asset.type }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">On Site:</td>
                                            <td class="value">{{ asset.daysOnSite }}</td>
                                        </tr>
                                        <tr *ngIf="asset.isIntegration">
                                            <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Waste Type:</td>
                                            <td class="value">{{ asset.wasteTypeName }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="row w-100 assets" *ngIf="isIntegrationCustomer === true">
                        <ng-container *ngFor="let group of groupedAssetsOnSite;">
                            <div class="row">
                                <div class="item col-6 d-flex align-items-stretch">
                                    <div class="card m-1 p-2 w-100 contract-label text-center">
                                        {{ group.order }}
                                    </div>
                                </div>
                            </div>
                            <div class="row border-bottom">
                                <ng-container *ngFor="let asset of group.assetsOnSite; let i = index;">
                                    <div class="item col-6 d-flex align-items-stretch">
                                        <div class="card m-1 w-100">
                                            <span class="container-icon text-primary me-2 me-md-0 relative-top--2" (click)="openPopup(asset.assetURL === null ? 'https://pinwebsiteimages.blob.core.windows.net/binreportimages/10000_OPN_image_front.jpg' : asset.assetURL)">
                                                <img src="/img/RoRo.png" *ngIf="asset.assetTypeClassification == 0">
                                                <img src="/img/Skip.png" *ngIf="asset.assetTypeClassification == 1">
                                            </span>
                                            <table class="asset-item">
                                                <tr>
                                                    <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Container:</td>
                                                    <td class="value">{{ asset.id }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Type:</td>
                                                    <td class="value">{{ asset.type }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">On Site:</td>
                                                    <td class="value">{{ asset.daysOnSite }}</td>
                                                </tr>
                                                <tr *ngIf="asset.isIntegration">
                                                    <td class="align-top text-uppercase py-1 pl-2 fw-bolder pr-4 label">Waste Type:</td>
                                                    <td class="value">{{ asset.wasteTypeName }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>                    
                </div>
            </div>      
          </div>
      </div>
      <div class="col-md-8 col-12 pl-1 flex-grow-1 d-flex flex-column">
        <div class="row pt-2">
            <div class="col-12 active-filters">
              <mat-form-field appearance="fill" style="width: 20%" class="pr-1">
                <mat-label>Vehicle</mat-label>
                <mat-select [(value)]="selectedVehicleId" (selectionChange)="vehicleChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
                  <mat-option *ngFor="let vehicle of customerVehicles" [value]="vehicle.id">{{vehicle.name}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" style="width: 28%" class="pr-1 pt-0">
                <mat-label>Date range</mat-label>
                <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
                  <input matStartDate #startDate placeholder="Start date" [value]="selectedStartDate">
                  <input matEndDate #endDate placeholder="End date" [value]="selectedEndDate" (dateChange)="selectedEndDateChange(startDate, endDate)">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
              </div>
          </div>
        <div appSetHeight [padding]="20" class="col-12 pl-0 pr-0 flex-grow-1">
          <div class="h-50 overflow-auto">
            <div class="table-box">
                <app-widget-jobs [jobs]="jobs" showFullDate="true"></app-widget-jobs>
            </div>
            <app-paging [paging]="jobsPaging" [pageChangeFunction]="changeJobsPage" [parentComponent]="this"></app-paging>
          </div>
          <div class="h-50 overflow-auto">
            <div class="table-box">
                <app-widget-services [services]="services" showFullDate="true"></app-widget-services>
            </div>
            <app-paging [paging]="servicesPaging" [pageChangeFunction]="changeServicesPage" [parentComponent]="this"></app-paging>
          </div>      
        </div>
      </div>
    </div>
  </div><app-image-popup
  [imageSrc]="selectedImage"
  [isOpen]="isPopupOpen"
  (close)="closePopup()"
></app-image-popup>
